// Calculate DoD status color: grey (none), light orange (all DoDs except last), green (last DoD)
export function getDoDStatusColor(value, options) {
  // If no value selected, return grey
  if (!value || value === "") {
    return "#808080"; // grey
  }
  
  // Find the index of the selected DoD
  const selectedIndex = options.findIndex(dod => dod.id === value);
  
  // If not found, return grey
  if (selectedIndex === -1) {
    return "#808080";
  }
  
  const totalDoDs = options.length;
  if (totalDoDs === 0) {
    return "#808080";
  }
  
  // Color definitions
  const LIGHT_ORANGE = "#ffb74d";
  const GREEN = "#32cd32"; // limegreen
  
  // Last DoD is always green
  if (selectedIndex === totalDoDs - 1) {
    return GREEN;
  }
  
  // All other DoDs are light orange
  return LIGHT_ORANGE;
}

// Helper function to clean dod_status by removing discipline IDs that don't exist or are excluded
export function cleanDodStatus(dodStatuses, disciplines) {
  if (!dodStatuses || typeof dodStatuses !== 'object') return {};
  
  const validDisciplineIds = new Set(disciplines.map(d => d.id));
  // Create a set of excluded discipline IDs
  const excludedDisciplineIds = new Set(
    disciplines.filter(d => d.excludeFromDoDs === true).map(d => d.id)
  );
  const cleaned = {};
  
  // Copy only valid discipline IDs that are not excluded
  Object.keys(dodStatuses).forEach(key => {
    if (key === '_hidden') {
      // Filter _hidden array to only include valid discipline IDs that are not excluded
      if (Array.isArray(dodStatuses._hidden)) {
        const filteredHidden = dodStatuses._hidden.filter(id => 
          validDisciplineIds.has(id) && !excludedDisciplineIds.has(id)
        );
        if (filteredHidden.length > 0) {
          cleaned._hidden = filteredHidden;
        }
      }
    } else if (validDisciplineIds.has(key) && !excludedDisciplineIds.has(key)) {
      // Only include discipline IDs that exist in current disciplines and are not excluded
      cleaned[key] = dodStatuses[key];
    }
  });
  
  return cleaned;
}

